import React from 'react';
import {AsyncComponent} from "../../../../../core/components/router/async-component";
import {MatchEventModulePlaceholder} from "./placeholders/match-event.module.placeholder";

const MatchEventsModuleAsyncComponent = AsyncComponent(async () => import('./match-events-module' /* webpackChunkName: "match-events-module" */ ));

export const MatchEventsModuleAsync = (props) => {
  return <React.Suspense fallback={<MatchEventModulePlaceholder/>}><MatchEventsModuleAsyncComponent {...props}/></React.Suspense>

}
